import { format } from "date-fns";

class ProductUtil {
    static transform(product) {
        let productPrices = [];
        if (product.prices) {
            product.prices.forEach(i =>
                productPrices.push({
                    productPriceId: i.productPriceId,
                    price: i.price,
                    startDate: i.startDate,
                    endDate: i.endDate,
                    fromQuantity: i.fromQuantity,
                    defaultDiscount : i.defaultDiscount,
                    productPriceTypeId: i.productPriceType ? i.productPriceType.productPriceTypeId : '',
                    mrp: i.mrp
                })
            )
        }
        if (product.productAttributes && product.productAttributes.length > 0) {
            product.productAttributes = product.productAttributes.map(i => {
                return  {
                    attributeId : i.attributeId,
                    productAttributeId : i.productAttributeId,
                    value : i.productAttributeValue ? i.productAttributeValue.value : '',
                    productAttributeValueId : i.productAttributeValue ?
                    i.productAttributeValue.productAttributeValueId : ''
                };
            })
        }

        return {
            productId: product.productId,
            name: product.name,
            purchasePrice: product.purchasePrice,
            taxId: product.taxId,
            unitId: product.unitId,
            minimumQuantity: product.minimumQuantity ? product.minimumQuantity : 1,
            hsn: product.hsn,
            barcode: product.barcode,
            isDisabled: product.isDisabled ? product.isDisabled : false,
            quantity: product.quantity ? product.quantity : 0,
            mrp: product.mrp,
            prices: product.prices.length > 0 ? productPrices : [
                {
                    startDate: format(new Date(), "YYYY-MM-DD"),
                    price: 0,
                    fromQuantity: 1,
                    defaultDiscount : null
                }
            ],
            productAttributes: product.productAttributes.length > 0 ? product.productAttributes : [
                {
                    attributeId: '',
                    value: ''
                }
            ],
            metadata : product.metadata
        }
    }
}

export default ProductUtil;